import { ShippingLocation_ } from 'src/api/db/apiShippingLocations'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/shared/components/ui/table'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { ShippingLocationRow } from './ShippingLocationRow'

interface ShippingLocationsTableProps {
  locations: ShippingLocation_[]
  isLoading: boolean
  onEdit: (location: ShippingLocation_) => void
  onDelete: (id: number) => void
}

export const ShippingLocationsTable = ({
  locations,
  isLoading,
  onEdit,
  onDelete,
}: ShippingLocationsTableProps) => {
  const { t } = useLocalization()

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="font-semibold text-gray-900">
              {t('LOCATION NAME', 'PLATSNAMN')}
            </TableHead>
            <TableHead className="font-semibold text-gray-900">
              {t('ADDRESS', 'ADRESS')}
            </TableHead>
            <TableHead className="font-semibold text-gray-900">
              {t('REGION', 'REGION')}
            </TableHead>
            <TableHead className="font-semibold text-gray-900">
              {t('STATUS', 'STATUS')}
            </TableHead>
            <TableHead className="font-semibold text-gray-900">
              {t('ACTIONS', 'ÅTGÄRDER')}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="text-center text-gray-500"
              >
                {t('Loading...', 'Laddar...')}
              </TableCell>
            </TableRow>
          ) : !locations || locations.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="text-center text-gray-500"
              >
                {t(
                  'No shipping locations found',
                  'Inga leveransplatser hittades'
                )}
              </TableCell>
            </TableRow>
          ) : (
            locations.map((location) => (
              <ShippingLocationRow
                key={location.id}
                location={location}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}

